<template>
  <div class="similar-clients-list">
    <p>Review similar clients</p>
    <div
      v-if="!clientName.length || !filteredEmployerList.length"
      class="similar-clients"
    >
      <p>Check here to confirm this is a new client</p>
    </div>

    <ul v-else>
      <li
        v-for="({ id, name }) in filteredEmployerList"
        :key="name"
      >
        <router-link
          :to="{
            name: 'ClientOverview',
            params: { clientId: id }
          }"
          target="_blank"
        >
          {{ name }}
          <tf-button
            type="primary"
            icon="external-link-alt"
            no-padding
            no-branding
            size="icon-no-fill"
          />
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import { getEmployerRfps } from '@/services/employer';

  /**
   * Review Similar Clients used in Employer Details
   * The validation rules are scoped to this instance but the parent controls the full employer validation state.
   * A mixin is shared as well for the other employer detail sections.
   *
   * @vuedoc
   * @exports Employer/Forms/SimilarClients
   * @category Components
   */
  export default {
    name: 'FormEmployerSimilarClients',
    props: {
      clientName: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      employers: [],
    }),
    computed: {
      /**
       * Return first four employers that match the employer name field
       *
       * @returns {Array}
       */
      filteredEmployerList() {
        return this.clientName
          ? this.employers
            .filter(({ name }) => name.toLowerCase().includes(this.clientName.toLowerCase()))
            .slice(0, 4)
          : [];
      },
    },
    /**
     * Fetch employers from the API then sort and map them to be filtered and rendered.
     *
     * @returns {Promise}
     */
    async created() {
      try {
        const { employers } = await getEmployerRfps();

        this.$set(
          this,
          'employers',
          this.$TF.Formatting
            .sortObjects(employers)
            .map(({ id, name }) => ({ id, name })),
        );
      } finally {
        this.isLoaded = true;
      }
    },
  };
</script>

<style lang="scss" scoped>
  .similar-clients-list {
    margin-bottom: 20px;

    > p {
      margin-bottom: 0;
      line-height: 40px;
    }
  }

  .similar-clients {
    background: $tf-extra-light-gray-1;
    border: 1px solid $tf-light-gray;
    border-radius: 2px;
    padding: 6px 15px 4px;
    color: $tf-light-gray;
    pointer-events: none;
  }

  ul {
    border-radius: 2px;
    background: $tf-white;
    border: 1px solid $tf-medium-gray;

    li {
      border-bottom: 1px solid $tf-extra-light-gray-1;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  a {
    display: flex;
    justify-content: space-between;
    font-weight: normal;
    padding: 10px 15px;
  }
</style>
